import React, { useState } from 'react';
import { VQ } from '../../../../../store/student/types';
import {
  DateInputWithConfirm,
  InputWithConfirm,
  getStringFromDate,
  getDateFromString,
  ContinueButton,
  isValidDate,
} from 'shared-components';
import { IAdditionalPassport, IDate } from '../../../../../types';

interface IProps {
  index: number;

  docNumber: string;
  placeOfIssue: string;
  issuingAuthority: string;
  issueDate: string;
  expiryDate: string;

  onSaveAndClose: (passport: IAdditionalPassport) => void;
}

const AdditionalPassports = (props: IProps) => {
  const { index, onSaveAndClose } = props;
  const [docNumber, setDocNumber] = useState(props.docNumber);
  const [placeOfIssue, setPlaceOfIssue] = useState(props.placeOfIssue);
  const [issuingAuthority, setIssuingAuthority] = useState(props.issuingAuthority);
  const [dIssue, setDIssue] = useState(() => getDateFromString(props.issueDate));
  const [dExpiry, setDExpiry] = useState(() => getDateFromString(props.expiryDate));
  const [dIssueError, setDIssueError] = useState('');
  const [dExpiryError, setDExpiryError] = useState('');

  const saveAndClose = () => {
    onSaveAndClose({
      docNumber,
      placeOfIssue,
      issuingAuthority,
      issueDate: getStringFromDate(dIssue),
      expiryDate: getStringFromDate(dExpiry),
    });
  };

  const handleOnSaveAndCloseClick = (_event: React.MouseEvent<HTMLButtonElement>) => {
    saveAndClose();
  };

  const validateDate = (dateValue: IDate): string => {
    const { YYYY, DD, MM } = dateValue;

    if (YYYY && DD && MM) {
      const isValid = isValidDate(dateValue);
      if (!isValid) {
        return "Doesn't look like a valid date";
      }
      return '';
    }

    return '';
  };

  const complete =
    docNumber !== '' &&
    placeOfIssue !== '' &&
    issuingAuthority !== '' &&
    dIssue.DD !== null &&
    dIssue.MM !== null &&
    dIssue.YYYY !== null &&
    dExpiry.DD !== null &&
    dExpiry.MM !== null &&
    dExpiry.YYYY !== null &&
    dIssueError === '' &&
    dExpiryError === '';

  return (
    <>
      <InputWithConfirm
        key={`${VQ.ADDITIONAL_PASSPORT_PASSPORT_NUMBER}-${index}`}
        id={`${VQ.ADDITIONAL_PASSPORT_PASSPORT_NUMBER}-${index}`}
        value={docNumber}
        label={'Additional passport or travel document number'}
        onChange={(evt: any) => {
          setDocNumber(evt.currentTarget.value);
        }}
      />

      <InputWithConfirm
        key={`${VQ.ADDITIONAL_PASSPORT_PLACE_OF_ISSUE}-${index}`}
        id={`${VQ.ADDITIONAL_PASSPORT_PLACE_OF_ISSUE}-${index}`}
        value={placeOfIssue}
        label={`Place of issue`}
        onChange={(evt: any) => {
          setPlaceOfIssue(evt.currentTarget.value);
        }}
      />

      <InputWithConfirm
        key={`${VQ.ADDITIONAL_PASSPORT_ISSUING_AUTHORITY}-${index}`}
        id={`${VQ.ADDITIONAL_PASSPORT_ISSUING_AUTHORITY}-${index}`}
        value={issuingAuthority}
        label={`Issuing authority`}
        onChange={(evt: any) => {
          setIssuingAuthority(evt.currentTarget.value);
        }}
      />

      <DateInputWithConfirm
        key={`${VQ.ADDITIONAL_PASSPORT_DATE_OF_ISSUE}-${index}`}
        id={`${VQ.ADDITIONAL_PASSPORT_DATE_OF_ISSUE}-${index}`}
        label={`Date of issue`}
        value={dIssue}
        errorText={dIssueError}
        onChangeDD={(evt: any) => setDIssue({ ...dIssue, DD: evt.target.value })}
        onChangeMM={(evt: any) => setDIssue({ ...dIssue, MM: evt.target.value })}
        onChangeYY={(evt: any) => setDIssue({ ...dIssue, YYYY: evt.target.value })}
        onBlur={(_evt: any) => setDIssueError(validateDate(dIssue))}
      />

      <DateInputWithConfirm
        key={`${VQ.ADDITIONAL_PASSPORT_DATE_OF_EXPIRY}-${index}`}
        id={`${VQ.ADDITIONAL_PASSPORT_DATE_OF_EXPIRY}-${index}`}
        label={`Date of expiry`}
        value={dExpiry}
        errorText={dExpiryError}
        onChangeDD={(evt: any) => setDExpiry({ ...dExpiry, DD: evt.target.value })}
        onChangeMM={(evt: any) => setDExpiry({ ...dExpiry, MM: evt.target.value })}
        onChangeYY={(evt: any) => setDExpiry({ ...dExpiry, YYYY: evt.target.value })}
        onBlur={(_evt: any) => setDExpiryError(validateDate(dExpiry))}
      />

      <ContinueButton index={index} complete={complete} handleOnSaveAndCloseClick={handleOnSaveAndCloseClick} />
    </>
  );
};

export default AdditionalPassports;
